export default "__VITE_ASSET__4659eb5d__"